import { render, staticRenderFns } from "./modalDesativaUsuario.vue?vue&type=template&id=28643c9d"
import script from "./modalDesativaUsuario.vue?vue&type=script&lang=js"
export * from "./modalDesativaUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports